export default {
  name: "TableElementsMixin",
  computed: {
    isCorrectValue() {
      if ("value" in this) {
        return this.value !== null && this.value !== undefined;
      }
    }
  }
};